var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg13S(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 336,
    viewBox: "0 0 224 336",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2127_400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.854 1H12.1464C5.99043 1 1 6.35654 1 12.9642V323.036C1 329.643 5.99043 335 12.1464 335H211.854C218.01 335 223 329.643 223 323.036V12.9642C223 6.35654 218.01 1 211.854 1Z",
    fill: "white",
    stroke: "#0B0B0B",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2127_400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.0498 17C42.6836 27 57.0498 33 57.0498 44.4C57.0498 45.9913 56.1595 47.5174 54.5746 48.6426C52.9898 49.7679 50.8404 50.4 48.5991 50.4C46.3578 50.4 44.2084 49.7679 42.6236 48.6426C41.0387 47.5174 40.1484 45.9913 40.1484 44.4C40.1484 44.2939 40.089 44.1922 39.9834 44.1172C39.8777 44.0421 39.7344 44 39.585 44C39.4356 44 39.2923 44.0421 39.1866 44.1172C39.081 44.1922 39.0216 44.2939 39.0216 44.4C39.0216 52.4 41.8385 53 44.3737 57H29.7259C32.2611 53 35.078 52.4 35.078 44.4C35.078 44.2939 35.0186 44.1922 34.913 44.1172C34.8073 44.0421 34.664 44 34.5146 44C34.3652 44 34.2219 44.0421 34.1162 44.1172C34.0106 44.1922 33.9512 44.2939 33.9512 44.4C33.9512 45.9913 33.0609 47.5174 31.4761 48.6426C29.8912 49.7679 27.7418 50.4 25.5005 50.4C23.2592 50.4 21.1098 49.7679 19.525 48.6426C17.9401 47.5174 17.0498 45.9913 17.0498 44.4C17.0498 33 31.416 27 37.0498 17Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2127_400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.471 145.739V136H133.647L119.059 162.435C119.529 161.739 121.882 159.652 124.235 159.652C133.647 159.652 136 168 136 178.435C136 192.348 132.235 200 122.824 200C113.412 200 112 188.87 112 188.87",
    stroke: "black",
    strokeWidth: 8,
    strokeMiterlimit: 1.5,
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_2127_400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.2 135.027C96.2065 136.121 96.2065 136.121 96.2131 137.237C96.2546 144.111 96.3012 150.984 96.3533 157.858C96.38 161.392 96.4047 164.925 96.425 168.459C96.4447 171.87 96.4694 175.28 96.4976 178.691C96.5075 179.992 96.5156 181.293 96.5218 182.594C96.5308 184.416 96.5463 186.239 96.5633 188.062C96.5704 189.099 96.5775 190.136 96.5848 191.205C96.7299 193.806 96.9058 195.309 97.8 197.434C99.4224 198.586 99.4224 198.586 101 199.217C101 199.805 101 200.394 101 201C95.896 201 90.792 201 85.5333 201C85.5333 200.412 85.5333 199.823 85.5333 199.217C87.9093 198.334 87.9093 198.334 90.3333 197.434C90.358 190.854 90.377 184.275 90.3886 177.695C90.3942 174.64 90.4017 171.585 90.4138 168.53C90.4276 165.018 90.4328 161.506 90.4375 157.994C90.443 156.896 90.4485 155.799 90.4542 154.668C90.4543 153.142 90.4543 153.142 90.4544 151.585C90.4568 150.688 90.4592 149.792 90.4616 148.868C90.428 146.397 90.428 146.397 89.2667 143.942C88.0347 144.236 86.8027 144.531 85.5333 144.834C85.3573 143.951 85.1813 143.068 85 142.159C86.3635 140.959 87.7303 139.773 89.1 138.593C89.4847 138.253 89.8693 137.913 90.2656 137.562C90.642 137.24 91.0184 136.919 91.4063 136.587C91.7498 136.288 92.0933 135.989 92.4473 135.682C93.7473 134.898 94.8272 134.982 96.2 135.027Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_2127_400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.95 319C181.316 309 166.95 303 166.95 291.6C166.95 290.009 167.841 288.483 169.425 287.357C171.01 286.232 173.16 285.6 175.401 285.6C177.642 285.6 179.792 286.232 181.376 287.357C182.961 288.483 183.852 290.009 183.852 291.6C183.852 291.706 183.911 291.808 184.017 291.883C184.122 291.958 184.266 292 184.415 292C184.564 292 184.708 291.958 184.813 291.883C184.919 291.808 184.978 291.706 184.978 291.6C184.978 283.6 182.161 283 179.626 279H194.274C191.739 283 188.922 283.6 188.922 291.6C188.922 291.706 188.981 291.808 189.087 291.883C189.193 291.958 189.336 292 189.485 292C189.635 292 189.778 291.958 189.884 291.883C189.989 291.808 190.049 291.706 190.049 291.6C190.049 290.009 190.939 288.483 192.524 287.357C194.109 286.232 196.258 285.6 198.499 285.6C200.741 285.6 202.89 286.232 204.475 287.357C206.06 288.483 206.95 290.009 206.95 291.6C206.95 303 192.584 309 186.95 319Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2127_400"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 224,
    height: 336,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2127_400"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 40,
    fill: "white",
    transform: "translate(17 17)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2127_400"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 72,
    fill: "white",
    transform: "matrix(-1 0 0 -1 140 204)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_2127_400"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 70,
    fill: "white",
    transform: "matrix(-1 0 0 -1 103 203)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_2127_400"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 40,
    fill: "white",
    transform: "matrix(-1 0 0 -1 207 319)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg13S);
export default __webpack_public_path__ + "static/media/13S.f84674e748fc2612d6034f0a792d3990.svg";
export { ForwardRef as ReactComponent };